import loggerService from '../../../../utils/loggerService';
import { CHECKOUT_EVENTS } from '../../../../shop/constants/angular-events';

const getAngularBody = async () => {
  try {
    await window.APP_EXTENSION_SDK_ANGULAR_JS_LOADED;
  } catch (error) {
    loggerService.error(
      new Error('Error waiting for APP_EXTENSION_SDK_ANGULAR_JS_LOADED'),
      { context: { error } },
    );

    return undefined;
  }

  return window.angular.element(document.body);
};

/**
 * Bind the onCartUpdate function to the cartService.fetch event
 * @param {Function} onCartUpdate - The callback function when cart is updated
 */
const bindOnCartUpdate = async (onCartUpdate) => {
  const angularBody = await getAngularBody();

  if (!angularBody) {
    return;
  }

  const $rootScope = angularBody.injector().get('$rootScope');
  const $bodyScope = angularBody.scope();

  $rootScope.$on(CHECKOUT_EVENTS.CART.ITEM.REMOVED, onCartUpdate);
  $bodyScope.$on('cart.reload', onCartUpdate);
};

export default bindOnCartUpdate;
